import React from 'react'
import { useDispatch } from 'react-redux'
import { NAVIGATION_POSTION } from '@utils/constants'
import useWindowSize from 'hooks/processor/useWindowSize'
import MobileNavigation from './MobileNavigation'
import TopNavigation from './TopNavigation'
import SideNavigation from './SideNavigation'
import VideoPlayerModal from '@components/modals/VideoPlayerModal'
import { BREAKPOINTS, LOCALSTORAGE_KEYS, userGuideMapping } from '@features/General'
import { rootActions } from '@store/slices'
import usePath from '@hooks/processor/usePath'

declare global {
    interface Window {
        userGuiding: any
    }
}
interface ILayout {
    layoutMode?:
        | 'step-layout'
        | 'basic'
        | 'dashboard'
        | 'exhibitor-onboarding'
        | 'event-details'
        | 'organizer-dashboard'
        | 'exhibitor-onboardin'
}

function Sider(props: ILayout) {
    const { layoutMode = 'dashboard' } = props
    const { width } = useWindowSize()
    const { path } = usePath()
    const dispatch = useDispatch()
    const siderMode = localStorage.getItem(LOCALSTORAGE_KEYS.NAVIGATION_POSTION)
    const showUserGuide = () => {
        const guideId = userGuideMapping[path]
        if (guideId) {
            window.userGuiding.previewGuide(guideId)
        }
    }

    const showVideoGuide = () => {
        dispatch(rootActions.ui.general.changeVideoPlayerModalVisiblity({ visible: true }))
    }

    return (
        <>
            <VideoPlayerModal />
            {width < BREAKPOINTS.MD ? (
                <MobileNavigation layoutMode={layoutMode} />
            ) : siderMode === NAVIGATION_POSTION.TOP && width > BREAKPOINTS.MD ? (
                <TopNavigation showUserGuide={showUserGuide} showVideoGuide={showVideoGuide} />
            ) : (
                <SideNavigation showUserGuide={showUserGuide} showVideoGuide={showVideoGuide} />
            )}
        </>
    )
}

export default Sider
